import React from "react";
import styled from "styled-components";
import CheckBox from "./checkbox";
import TextArea from "./textArea";

const Container = styled.div`
    border: 1px solid rgba(19, 34, 149, 0.1);
    border-radius: 6px;
    padding: 9px;
`;

const CheckBoxContainer = styled.div`
    padding: 6px;
`;

function CheckBoxWithComments({
    options,
    optionsValues,
    setOptionsValues,
    isEditable,
    placeholder,
}) {
    const onChange = (id, value, key) => {
        if (!key) {
            if (value) {
                setOptionsValues({
                    ...optionsValues,
                    [id]: {},
                });
            } else {
                const updatedOptions = { ...optionsValues };
                delete updatedOptions[id];
                setOptionsValues(updatedOptions);
            }
        } else {
            setOptionsValues({
                ...optionsValues,
                [id]: {
                    ...optionsValues[id],
                    [key]: value,
                },
            });
        }
    };

    return (
        <Container>
            {options?.map((option) => (
                <div key={option.id}>
                    <CheckBoxContainer>
                        <CheckBox
                            label={option.label}
                            key={option.id}
                            value={optionsValues[option.id]}
                            onChange={(e) => onChange(option.id, e.target.checked)}
                            disabled={!isEditable}
                        />
                    </CheckBoxContainer>

                    {optionsValues[option.id] && (
                        <TextArea
                            placeholder={placeholder}
                            type="text"
                            value={optionsValues[option.id]?.comment}
                            onChange={(e) => onChange(option.id, e.target.value, "comment")}
                            isEditable={isEditable}
                            disabledWithBorder
                        />
                    )}
                </div>
            ))}
        </Container>
    );
}

export default CheckBoxWithComments;
